export default __webpack_public_path__ + "static/media/Group1409.28125f1d.svg";